<template>
    <div class="c-a-input" :class="{'c-a-input--invalid': invalid}">
        <label class="c-a-input__label" :for="`question-${id}`">{{label}}<span v-if="required"> *</span></label>
        <div class="c-a-input__wrapper" :class="{'c-a-input__wrapper--with-icon-left': icon}">
            <icon
                v-if="icon"
                class="c-a-input__icon"
                :icon="icon"></icon>
            <input
                v-if="userInfo"
                type="email"
                class="c-a-input__input"
                :id="`question-${id}`"
                v-model="userInfo"
                disabled
            />
            <input
                v-else
                type="email"
                class="c-a-input__input"
                :placeholder="placeholder"
                :id="`question-${id}`"
                v-model="textValue"
                @input="updated(textValue)"
            />
        </div>
    </div>
</template>

<script>
    import Icon from '../AtomIcon.vue';
    export default {
        components: {
            Icon
        },
        props:{
            id: Number,
            icon: String,
            label: String,
            dataKey: String,
            disabled: Boolean,
            invalid: Boolean,
            required: Boolean,
            placeholder: String,
            userInfo: String,
        },
        data(){
            return {
                textValue: '',
            }
        },
        methods:{
            updated(answer){
                const data = {
                    questionId: this.id,
                    label: this.label,
                    answers: answer,
                    text:true
                };

                if(this.dataKey){
                    data.dataKey = this.dataKey;
                }

                this.$emit('updateData', data);
            },
        },
        updated() {
            // if there is a propped userInfo, the affected field is automatically updated
            if(this.userInfo) {
                this.updated(this.userInfo);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/components/atoms/request-form/AtomInputEmailRequestForm.vue